var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 12.5259C10.5011 13.0656 10.0647 13.5042 9.525 13.5059H1.725C1.46571 13.5053 1.21727 13.4018 1.03439 13.2179C0.851515 13.0341 0.749208 12.7851 0.750005 12.5259V1.73586C0.749474 1.47648 0.852004 1.22751 1.03504 1.04372C1.21807 0.859937 1.46662 0.756389 1.726 0.755859L9.526 0.768859C10.0654 0.771064 10.5011 1.2095 10.5 1.74886V12.5259Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2461 6.54389C23.2422 7.07866 22.8059 7.50921 22.2711 7.50589H14.4711C14.2142 7.50775 13.9671 7.40741 13.7842 7.22697C13.6013 7.04653 13.4977 6.80079 13.4961 6.54389V1.73089C13.4994 1.19666 13.9349 0.766116 14.4691 0.768885L22.2691 0.755885C22.8044 0.752004 23.2417 1.18256 23.2461 1.71789V6.54389Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 22.2909C10.4984 22.5484 10.3946 22.7948 10.2114 22.9757C10.0281 23.1567 9.78053 23.2575 9.523 23.2559L1.723 23.2429C1.18822 23.2451 0.752755 22.8137 0.75 22.2789V17.4699C0.751322 17.2127 0.854821 16.9666 1.0377 16.7858C1.22058 16.605 1.46783 16.5043 1.725 16.5059H9.525C10.0603 16.5031 10.4967 16.9346 10.5 17.4699V22.2909Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4721 23.2559C14.2125 23.2553 13.9638 23.1516 13.7808 22.9676C13.5977 22.7836 13.4953 22.5344 13.4961 22.2749V11.4869C13.4953 11.2275 13.5976 10.9784 13.7804 10.7944C13.9633 10.6105 14.2117 10.5067 14.4711 10.5059H22.2711C22.5305 10.5067 22.7789 10.6105 22.9618 10.7944C23.1446 10.9784 23.2469 11.2275 23.2461 11.4869V22.2619C23.2472 22.8014 22.8116 23.2401 22.2721 23.2429L14.4721 23.2559Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInactive);
export default __webpack_public_path__ + "static/media/dashboard-Inactive.e229ed46acc3afd77be6bf287bf3ae32.svg";
export { ForwardRef as ReactComponent };